module.exports = __webpack_public_path__ + "static/img/f3b780f3-0411-4a0e-9075-78974358d606.94b97799.png";